import { render, staticRenderFns } from "./interaction-component.vue?vue&type=template&id=7389e2e8&"
import script from "./interaction-component.vue?vue&type=script&lang=ts&"
export * from "./interaction-component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports